import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">Patent Pending • Trademark Filed</div>
          <h1 className="hero-title">
            Transform Your Pet's Photos Into Magical Video Stories
          </h1>
          <p className="hero-description">
            BarkBacks uses AI to bring your pet's personality to life through personalized video narratives.
            Watch as your furry friend tells their own story!
          </p>
          <div className="hero-buttons">
            <Link to="/app/register" className="btn btn-primary">Get Started Free</Link>
            <Link to="/for-businesses" className="btn btn-secondary">For Businesses</Link>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-value">10,000+</div>
              <div className="stat-label">Videos Created</div>
            </div>
            <div className="stat">
              <div className="stat-value">98%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </div>
            <div className="stat">
              <div className="stat-value">500+</div>
              <div className="stat-label">Pet Care Partners</div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2>How BarkBacks Works</h2>
        <p className="section-description">Create magical video memories in three simple steps</p>
        <div className="steps-grid">
          <div className="step-card">
            <div className="step-icon">📸</div>
            <h3>1. Upload Photo</h3>
            <p>Choose your favorite photo of your pet</p>
          </div>
          <div className="step-card">
            <div className="step-icon">🎭</div>
            <h3>2. Choose Personality</h3>
            <p>Select a voice and personality that matches your pet</p>
          </div>
          <div className="step-card">
            <div className="step-icon">🎬</div>
            <h3>3. Get Your Video</h3>
            <p>Receive a personalized video story starring your pet</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2>Platform Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <h3>AI-Powered Narratives</h3>
            <p>Advanced AI creates unique stories tailored to your pet's personality</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎨</div>
            <h3>Custom Personalities</h3>
            <p>Choose from playful, wise, dramatic, and more voice personalities</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Quick Generation</h3>
            <p>Get your personalized video in minutes, not hours</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💝</div>
            <h3>Shareable Memories</h3>
            <p>Download and share your pet's stories with friends and family</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Bring Your Pet's Story to Life?</h2>
        <p>Join thousands of pet parents creating magical memories</p>
        <div className="cta-buttons">
          <Link to="/app/register" className="btn btn-primary btn-large">Create Your First BarkBack</Link>
          <Link to="/how-it-works" className="btn btn-secondary btn-large">Learn More</Link>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
